import { DecimalFormatOptions, IntegerFormatOptions } from 'interfaces-lib';

export class Adv2Config {
  config: {
    clientId: string;
    dateFormat: string;
    signatureId: string;
    signatureProviderName: string;
    emptyFields: EmptyFields;
    filterFields: {
      bullhorn: {
        CorporateUser: ['userType', 'departments'];
        Settings: ['privateLabelId'];
      };
    };
    outputFormat: string;
    salesforce?: ISalesforceConfig;
    errorNotificationEmail?: string | null;
    integerFormat?: IntegerFormatOptions;
    decimalFormat?: DecimalFormatOptions;
  };
  signature: {
    providerName: string;
    id: string;
    name: string;
    accountId: string;
    userId: string;
    server: string;
    sendOnBehalf: boolean;
    scope: string;
    properties: {
      editEnvelope: true;
    }
  };
}

export type EmptyFields = {
  byType: [{ key: string; value: string }];
  byIdentifier: [{ key: string; value: string }];
};

export enum EmptyFieldType {
  BY_TYPE = 'Field type',
  BY_IDENTIFIER = 'Field name',
}

export interface ISalesforceConfig {
  objects: ISalesforceObjectMapping[];
}

export interface ISalesforceObjectMapping {
  id: string;
  label?: string;
  objectName: string;
  enabled: boolean;
  fields: ISalesforceFieldMapping[];
  display?: ISalesforceDisplayTemplates;
  relatedObjects?: ISalesforceRelatedObject[];
}

export interface ISalesforceRelatedObject {
  objectName: string;
  relationSegment: string;
}

export interface ISalesforceFieldMapping {
  label?: string;
  path: string;
  dataType?: string;
}

export interface ISalesforceDisplayTemplates {
  primary: string;
  secondary?: string;
}
